import { useCallback } from "react";

export type NavigationOptions = {
    onNavigate?: (item: { id: string; href?: string; anchor?: string }) => void;
    scrollBehavior?: ScrollBehavior;
    scrollOffset?: number;
};

export function useNavigation({
    onNavigate,
    scrollBehavior = "smooth",
    scrollOffset = 90,
}: NavigationOptions = {}) {
    const handleNavigation = useCallback(
        (item: {
            id: string;
            href?: string;
            anchor?: string;
            onClick?: () => void;
        }) => {
            if (item.onClick) {
                item.onClick();
                return;
            }

            if (item.anchor) {
                const element = document.getElementById(item.anchor);
                if (element) {
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition =
                        elementPosition + window.scrollY - scrollOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: scrollBehavior,
                    });
                    window.history.replaceState(null, "", `#${item.anchor}`);
                }
                onNavigate?.(item);
                return;
            }

            if (item.href) {
                if (item.href.startsWith("http")) {
                    window.open(item.href, "_blank", "noopener,noreferrer");
                } else {
                    onNavigate?.(item);
                }
                return;
            }

            onNavigate?.(item);
        },
        [onNavigate, scrollBehavior, scrollOffset],
    );

    return { handleNavigation };
}

export default useNavigation;
